import { gql } from '@apollo/client';
const GET_WAREHOUSE_RELEASE_MODEL = gql `
  query GetWarehouseReleaseModel($id: ID!) {
    node(id: $id) {
      ... on WarehouseReleaseModelNode {
        id
        colors {
          edges {
            node {
              id
              name
              correspondingColor {
                id
                name
              }
            }
          }
        }
        sizes {
          edges {
            node {
              id
              name
              correspondingSize {
                id
                sizeName {
                  id
                  name
                }
              }
            }
          }
        }
        variants {
          edges {
            node {
              id
              quantity
              warehouseReleaseModelSize {
                id
                name
                correspondingSize {
                  id
                  sizeName {
                    id
                    name
                  }
                }
              }
              warehouseReleaseModelColor {
                id
                name
                correspondingColor {
                  id
                  name
                }
              }
              correspondingSpecificationVariant {
                id
                quantity
                color {
                  id
                  name
                  isActive
                }
              }
            }
          }
        }
        modelSpecification {
          id
          fancyName
          folder {
            id
            name
          }
        }
        ready
        isSetToReadyAvailable
      }
    }
  }
`;
export default GET_WAREHOUSE_RELEASE_MODEL;
